module.exports = __webpack_public_path__ + "static/media/rocket.0c5f3b88.svg";